import React from 'react';
import { Box, BaseLink, StyledButton } from 'src/kit';
import { LText } from 'src/kit/landingKit';
import Input from 'src/components/Input';

const Form = ({ t, handleSubmit, submitting }) => (
  <form onSubmit={handleSubmit}>
    <Input variant="auth" name="hire" placeholder={t('I need to hire')} isValidated={false} mb={15} />
    <Input variant="auth" name="company_name" placeholder={t('My company is')} mb={15} />
    <Input variant="auth" name="email" placeholder={t('My email is')} mb={15} />
    <Input variant="auth" name="phone" type="phone" placeholder={t('Phone number')} mb={30} />
    <Box maxWidth={290} mb={50}>
      <LText fontSize={1} mb={0}>
        {t('By clicking «Send a request», you agree to the ')}
      </LText>
      <BaseLink
        href="/Terms and Conditions Employers.pdf"
        target="_blank"
        variant="primary"
        display="inline"
        fontSize={1}
      >
        {t('Sainoo Terms')}
      </BaseLink>
    </Box>
    <StyledButton type="submit" disabled={submitting} mb={25} variant="bPrimary" size="lg" textStyle="normal">
      {t('Send a request')}
    </StyledButton>
  </form>
);

export default Form;
